module.exports = __webpack_public_path__ + "static/media/focus.c7f6d1ad.svg";